import BaseModelFactory from './base.factory'
import UniversitySessionService from './../services/UniversitySession.service'
import UniversitySession from './../models/university-session.model'

class UniversitySessionFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: UniversitySessionService, Model: UniversitySession }
    )
  static findById = async id =>
    await this._findBy({ id }, { Service: UniversitySessionService, Model: UniversitySession })
  static create = payload =>
    this._create(payload, {
      Service: UniversitySessionService,
      Model: UniversitySession,
    })
}

export default UniversitySessionFactory
